import { SectionTabbed, Copy, Controls, Media, Picture } from './SectionTabbed';
SectionTabbed.displayName = "SectionTabbedBase";
Copy.displayName = "SectionTabbed.Copy";
Controls.displayName = "SectionTabbed.Controls";
Media.displayName = "SectionTabbed.Media";
Picture.displayName = "SectionTabbed.Picture";
export { default, Copy, Media, Picture, Controls } from './SectionTabbed';
export { Image } from './__stories__/Image';